export const ONBOARDING_PAPER_CLASS_NAME = 'onboarding-paper';
export const HOME_INFO_CARD_PAPER_CLASS_NAME = 'home-info-card-paper';

export const RESERVE_SCROLLBAR_GUTTER_ATTR = 'data-reserve-scrollbar-gutter';
